// Capture helpers still used after the setup checklist became Settings, Cards and banks and the
// add-a-card flow (web/src/views/cards-banks.ts, web/src/views/card-flow.ts): the silence warning
// on Overview and one line per forwarded message.
import type { InboundActivityDto, OverviewDto } from '../../../shared/api';
import { silenceText } from '../../../shared/setup-copy';
import { esc, money } from '../format';

/** "No <bank> alerts in N days. Check your Gmail filter." Dismissible. */
export function vSilence(d: OverviewDto, compact = false): string {
  return d.silenceWarnings
    .map(
      (w) =>
        `<div class="silence${compact ? ' compact' : ''}"><span>${esc(silenceText(w.bank, w.days))}</span><button class="btn" data-a="silence-dismiss" data-key="${esc(w.key)}" aria-label="Dismiss">Dismiss</button></div>`,
    )
    .join('');
}

/** One line per forwarded message. */
export function mailLine(m: InboundActivityDto): string {
  switch (m.kind) {
    case 'logged':
      return m.merchant && m.amountCents !== null ? `Logged ${m.merchant}, ${money(m.amountCents, 2)}` : 'Logged a purchase';
    case 'skipped':
      return 'Skipped an alert that was not a purchase';
    case 'ignored':
      return "Ignored an email that doesn't look like a card alert";
    case 'held':
      return 'Held an alert from a new address';
    case 'verification':
      return "Gmail's forwarding code";
    case 'failed':
      return "Couldn't read this alert";
    case 'taught':
      return 'Read an alert you forwarded to learn a bank';
    case 'not-taught':
      return 'An email you forwarded did not read as a purchase alert. Nothing was kept.';
  }
}

